<app-base-modal
  [title]="audienceResourceType.name"
>
  <div class="content">
    @if (audienceParams) {
        <app-audience-age-card
          [audienceParams]="audienceParams"
          [isEditEnabled]="true"
        />
    }
    <mat-divider></mat-divider>
    @if (audienceParams) {
      <div>
        <app-audience-geo-card
          [audienceParams]="audienceParams"
          [isEditEnabled]="true"
        />
      </div>
    }
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      (click)="closeDialog('cancel')"
    >
      Назад
    </button>
    <button
      mat-button
      color="accent"
      (click)="handleSaveButtonClick()"
    >
      Сохранить
    </button>
  </div>
</app-base-modal>
